import moment from "moment";
import React from "react";
import { useFormState } from "react-final-form";
import CustomDatePickerInput from "./CustomDatePickerInput";

interface ICustomEndDate {
  source: string;
  comparison?: string;
  label?: string;
  parentStartDate?: string;
  parentEndDate?: string;
  excludeDates?: IExcludeDates[];
  isWeekdays?: boolean;
  isDisabled?: boolean;
}

const CustomEndDateInput = ({
  source,
  label,
  parentStartDate,
  parentEndDate,
  comparison,
  excludeDates,
  isWeekdays,
  isDisabled,
}: ICustomEndDate) => {
  const { values } = useFormState();

  return (
    <>
      {parentStartDate ? (
        <CustomDatePickerInput
          name={source}
          label={label}
          min={
            parentStartDate < moment().format("yyyy-MM-DD")
              ? moment().format("yyyy-MM-DD")
              : parentStartDate
          }
          max={parentEndDate}
          excludeDates={excludeDates}
          isWeekDays={isWeekdays}
          disableValue={isDisabled}
        />
      ) : parentEndDate ? (
        <CustomDatePickerInput
          name={source}
          label={label}
          min={
            values[comparison] === undefined
              ? moment().format("yyyy-MM-DD")
              : values[comparison]
          }
          max={parentEndDate}
          excludeDates={excludeDates}
          isWeekDays={isWeekdays}
          disableValue={isDisabled}
        />
      ) : (
        <CustomDatePickerInput
          name={source}
          label={label}
          min={
            values[comparison] === undefined
              ? moment().format("yyyy-MM-DD")
              : values[comparison]
          }
          excludeDates={excludeDates}
          isWeekDays={isWeekdays}
          disableValue={isDisabled}
        />
      )}
    </>
  );
};

export default CustomEndDateInput;
